import YAML from '../../services/yaml';

// If sweep.displayName is not set, it'll use the name field from sweep config json
export function getSweepDisplayName(
  sweep?: {
    name: string;
    displayName?: string | null;
    config?: string;
  } | null
): string {
  if (sweep == null) {
    return '';
  }
  if (sweep.displayName != null) {
    return sweep.displayName;
  }
  if (sweep.config != null) {
    let parsedConfig;
    try {
      parsedConfig = YAML.parse(sweep.config);
    } catch (e) {
      console.error('Error parsing sweep config to get display name', e);
      return sweep.name;
    }
    const config = parsedConfig;
    const nameFromConfig = config.name?.value || config.name;
    if (nameFromConfig && typeof nameFromConfig === 'string') {
      return nameFromConfig;
    }
  }
  return sweep.name;
}
